
import colors from "assets/theme-dark/base/colors";

const { dark, light } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: light.main,
      "&.Mui-disabled": {
        color: `${dark.main}`,
      },
    },
  },
};

export default formLabel;
